import { render } from "./Vacaciones.vue?vue&type=template&id=0d5cd38b&scoped=true"
import script from "./Vacaciones.vue?vue&type=script&lang=js"
export * from "./Vacaciones.vue?vue&type=script&lang=js"

import "./Vacaciones.vue?vue&type=style&index=0&id=0d5cd38b&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5cd38b"]])

export default __exports__